import { ISheetCalculationBatch } from 'modules/payrollProcessorHub/store/model';
import { ICalculation } from 'store/entities/timesheet/models/Calculation';

export function getAllCalculationItems(calculationGroup?: ISheetCalculationBatch | undefined): Array<ICalculation> {
    const { expense_calculations = [], time_calculations = [] } = calculationGroup || {};
    return [...expense_calculations, ...time_calculations];
}
